import React from 'react';
import { Link } from 'react-router-dom';

const Itemnews = (props) => {
    return (
        <Link
            className="item-news"
            to={`/News/inner-page/${props.id}`} >
            <div className="pic">
                <img src={props.pic} />
            </div>
            <h4>{props.title}</h4>
            <div className="list-tags">
                {props.tags.length == 0 ? null : props.tags.map(info =>
                    <span key={info.name}>{info.name}</span>
                )}
            </div>
            <div className="row-detailes">
                <span>{props.time}</span>
                <span>{props.comment}<i className="icon-comment"></i></span>
            </div>
        </Link>
    );
}

export default Itemnews;